// Single source of truth for all copy + shared constants.

// All CTA buttons link here (Shopify checkout).
export const CART_LINK = 'https://tupolleriarentable.com/cart/53878176121196:1'

// Prices are expressed in the product's base currency (ARS).
// The numeric values below are the "raw" amounts; PriceDisplay formats them.
export const PRICE = {
  today: 29990,
  next: 359999,
  crossed: [99999, 59999] as const,
  totalValue: 432990,
}

export const HERO = {
  eyebrow:
    'Se Anuncia: El Sistema Más Completo Para Montar y Hacer Rentable Tu Pollería en 30 Días',
  soundNote:
    'Asegurate de tener el sonido activado. Por favor esperá unos segundos a que cargue el video.',
  headline:
    'Mirá Este Video Hasta El Final Y Accedé A Los 20+ Videos, Las 3 Calculadoras y Todos Los Bonos',
  offerLabel: 'Oferta de Lanzamiento',
  cta: 'COMPRAR AHORA',
  ctaSub: 'Accedé Ahora Mismo A Pollería Rentable 2026 »',
  singlePayment: 'Esto es un pago único.',
  scarcity:
    'Me reservo el derecho de cerrar esta oferta en cualquier momento después del 9 de agosto de 2026.',
}

export const PAIN_INTRO = {
  from: 'Desde el Escritorio de Franco R.',
  re: 'Re: Cómo hacer rentable tu pollería sin roturas de cabeza…',
  greeting: 'Estimado Colega Pollero,',
  question: '¿Alguna vez…?',
}

export const PAINS = [
  '¿Sentís que por más que te rompas laburando para otro, el techo de cuánto podés ganar ya está puesto de antemano?',
  '¿Pensaste «con lo que gano en un mes de laburo en blanco, podría estar armando algo mío»?',
  '¿Soñás con el día en que el que decide los horarios, los precios y las reglas seas vos y nadie más?',
  '¿Te preguntaste cuántos años más vas a esperar «el momento justo» para largarte a hacer algo propio?',
  '¿Soñás con un negocio de familia — donde tu pareja, tu hijo o tu hermano puedan sumarse y vivir de lo mismo que vos?',
  '¿Pensaste que con un local propio podrías organizar tu tiempo alrededor de tu familia, y no al revés?',
  '¿Sentís que ya hiciste el esfuerzo de «empezar de cero» en un trabajo en blanco y aun así no ves la salida?',
  '¿Querés progresar de verdad, no solo sobrevivir el mes, y no sabés por dónde empezar sin plata de sobra?',
]

export const STORY_BLOCKS: string[] = [
  'Estos son los mismos problemas que yo enfrenté cuando recién arrancaba con un cajón de pollo prestado…',
  '…y son los mismos problemas que siguen frenando hoy a cientos de polleros y polleras de barrio en toda la Argentina.',
]

export const PROBLEM_SECTION = {
  title: 'Acá Está El Gran Problema…',
  intro:
    'Cuando yo arrancaba y buscaba ayuda para no fundirme, esto fue lo que encontré: la mayoría de los «consejos» gratis para poner una pollería son BASURA PURA.',
  subtitle: 'Fijate por qué:',
  bullets: [
    'Los videos de YouTube y TikTok solo enseñan pollo a la brasa peruano — nada que ver con la realidad de un mostrador argentino, un cajón crudo y un cliente que te discute el precio del kilo.',
    'Los «consejos» del cuñado, del vecino o del amigo que «una vez vendió pollo» — que nunca pusieron un peso propio ni sostuvieron un local un mes entero.',
    'Los cursos genéricos de emprendedurismo del Estado, llenos de power points y cero cancha — nunca te dicen cuánto rinde un cajón ni cómo detectar que te están metiendo agua por pollo.',
    'Pagarle todos los meses a un contador por algo que, con las herramientas correctas, podés resolver vos mismo en cinco minutos desde el celular.',
  ],
  outro: [
    'Vi a un pibe abrir con toda la garra, comprar el cajón más caro pensando que así ganaba más, y terminar regalando la mitad del pollo porque no sabía calcular el rinde ni el precio de venta.',
    'Otro me contó que descubrió recién al tercer mes que el «pollo fresco» que le vendían pesaba distinto según el día — nadie le había explicado cómo pesar el hielo y el agua para no pagar de más.',
    'Así que agarré papel, calculadora y años de mostrador, y le armé el cálculo real, cajón por cajón, para que no le pasara lo mismo a nadie más.',
  ],
}

export const SOLUTION_INTRO = {
  title: 'Así Que Decidí Solucionar Todo Eso…',
  paragraphs: [
    'Con este sistema el techo de cuánto ganás lo ponés vos: te enseño a calcular tu rinde y tus precios reales para que cada cajón te deje lo que realmente vale tu trabajo, no lo que te sobra después de que todos los demás cobraron primero.',
    'No hace falta esperar «el momento justo» ni tener una fortuna ahorrada: te muestro exactamente cuánto invertir y cómo arrancar de a poco, con lo que ya tenés, para que ese «algo mío» que pensás cada fin de mes deje de ser una idea y se vuelva un plan concreto.',
    'Es un sistema pensado para armar con tu familia, para que tu pareja, tu hijo o tu hermano puedan sumarse y vivir del mismo negocio que vos, no de sueldos separados.',
    'Vos decidís los horarios, los precios y las reglas — nadie más. Te doy las herramientas (calculadoras, trámites resueltos, proveedores) para que manejar tu propio local no dependa de la suerte, sino de un método que ya funcionó para otros polleros como vos.',
    'Este es el paso que te saca de «empezar de cero» otra vez: no es un trabajo nuevo en relación de dependencia, es el mismo esfuerzo que ya venís poniendo, pero ahora construyendo algo tuyo, con un camino claro para progresar de verdad y no solo llegar a fin de mes.',
  ],
}

export const PRODUCT_REVEAL = {
  kicker: 'Te Presento…',
  name: 'Pollería Rentable 2026',
  tagline:
    '«El Sistema Completo Para Iniciar y Hacer Rentable Tu Negocio de Venta de Pollo»',
  promise:
    'Montá y hacé rentable tu pollería en 30 días — sacándole hasta un 30% más de ganancia al mismo cajón de pollo que ya estás comprando…',
  promise2:
    '…aunque hoy no tengas ni idea de bromatología, ni sepas calcular un rinde, ni tengas ni un peso ahorrado de más.',
}

export const FEATURES = [
  {
    tag: 'Característica #1',
    title: 'El Módulo de los Secretos',
    body: 'Te enseño, con el pollo en la mano, cómo detectar si el pollo que te venden viene inyectado con agua, cómo sacarle el máximo rinde a cada cajón y cómo no tirar ni los menudos.',
    note: 'Es como tener a un pollero de toda la vida parado al lado tuyo en el mostrador, mostrándote exactamente dónde está la plata que hoy estás dejando pasar.',
    img: 'https://cdn.magicpatterns.com/uploads/vVqagaXuETz4Jz1iefBYt7/2-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/3cd7fw76JBefUSRqCwJgjz/2-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/6tHjCLtfkVN2m5DZB7WQhk/2-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/uG8mGTefnGoT7V3Vda9F12/2-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/vVqagaXuETz4Jz1iefBYt7/2-700.jpg',
    },
  },
  {
    tag: 'Característica #2',
    title: '3 Calculadoras Listas Para Usar Desde El Celu',
    body: 'Te llevás la Calculadora de Rinde del Pollo, la Calculadora para Marcar Precios y la Lista de Proveedores — todas listas para completar con tus propios números.',
    note: 'Se acabó lo de poner precios «a ojo». Vas a saber tu costo real por kilo antes de abrir la persiana cada mañana.',
    img: 'https://cdn.magicpatterns.com/uploads/fNNkj6sFp7GSeLPEhZxqYp/3-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/7SY3268Pc1cDwVgiYEEM93/3-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/gDdkrC33DMKWGHLyFkv9ui/3-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/utdrt6uadBdkZh1FuDE1cJ/3-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/fNNkj6sFp7GSeLPEhZxqYp/3-700.jpg',
    },
  },
  {
    tag: 'Característica #3',
    title: 'Habilitación, Bromatología y Cobros — Paso a Paso',
    body: 'La parte que nadie enseña: cómo resolver la habilitación municipal y la bromatología sin perderte en trámites, y cómo cobrar con Mercado Pago sin que las comisiones te coman la ganancia del día.',
    note: 'Cuando las instrucciones son así de claras, el trámite deja de ser una montaña. Se resuelve solo, un paso a la vez.',
    img: 'https://images.unsplash.com/photo-1604503468506-a8da13d82791?auto=format&fit=crop&w=800&q=70&fm=webp',
  },
  {
    tag: 'Característica #4',
    title: 'Método Probado En La Vida Real, No En Un Aula',
    body: 'Todo adaptado a proveedores, precios y trámites argentinos — no a recetas peruanas ni a manuales genéricos traducidos de otro país.',
    note: 'Vas a ver exactamente cómo se hace, filmado por un pollero de verdad, no explicado por alguien que jamás pesó un cajón.',
    img: 'https://cdn.magicpatterns.com/uploads/si2K73jMBrgHzgWHYwoMUV/4-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/5WCeSYNStS1fz3V6EXgGkG/4-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/sCZJ1HAUckG36yHTtb94oB/4-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/mbCiC6dH1JbHkFtaqTfDX9/4-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/si2K73jMBrgHzgWHYwoMUV/4-700.jpg',
    },
  },
  {
    tag: 'Característica #5',
    title: 'Sirve Para El Que Empieza Y Para El Que Ya Tiene Un Local',
    body: 'Tenemos módulos para el que arranca de cero y también para el que ya tiene su pollería hace años pero siente que labura para el proveedor y no le queda nada.',
    note: 'No hace falta que seas contador ni que tengas un local enorme. Ya sea que estés por abrir tu primer cajón o que quieras por fin sacarle rentabilidad real al local que ya tenés, hay un módulo hecho para tu situación.',
    img: 'https://cdn.magicpatterns.com/uploads/pHgSMLvZpiw7kKaQ2RNZ26/5-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/aujSumB9nEsunD37dn6nmg/5-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/hneyTTvXXrn6GaTsCFtq5C/5-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/jkQDzbmAnbpQUC7y2kApKV/5-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/pHgSMLvZpiw7kKaQ2RNZ26/5-700.jpg',
    },
  },
]

export const TESTIMONIALS = [
  {
    title: 'El Mejor Sistema Que Vi Para Esto',
    quote:
      'Probé de todo: videos, cuñados, hasta un curso del municipio. Nada bajaba a la realidad del mostrador como esto. Las calculadoras solas ya me cambiaron el mes. Si estás por abrir, esto es una ganga.',
    name: 'Rubén A.',
    location: 'La Matanza',
    img: 'https://cdn.magicpatterns.com/uploads/bcBM6vu35NuvuJwzvHFzrZ/Fotografa_hiperrealista_tipo_s_Nano_Banana_2_45089.png',
  },
  {
    title: 'Por Fin Entendí Por Qué No Me Quedaba Plata',
    quote:
      'Tengo la pollería hace 4 años y pensaba que «así era el negocio». Con el módulo de rinde me di cuenta que estaba regalando casi el 20% del cajón sin saberlo. Ahora lo primero que hago cada mañana es la cuenta con la calculadora.',
    name: 'Marisa D.',
    location: 'Rosario',
    img: 'https://cdn.magicpatterns.com/uploads/bK2prSTRiVr6icqwv7dVVC/Fotografa_hiperrealista_tipo_s_Nano_Banana_2_82050.png',
  },
  {
    title: 'Me Sacó El Miedo De Encima',
    quote:
      'Lo que más me frenaba era la habilitación, pensaba que era un quilombo carísimo. Acá está explicado paso a paso, sin vueltas. Ya arranqué el trámite y no fue ni la mitad de lo que imaginaba.',
    name: 'Walter C.',
    location: 'Córdoba',
    img: 'https://cdn.magicpatterns.com/uploads/dXZDEg3UAeXNhYTCwCB2m6/Fotografa_hiperrealista_tipo_s_Nano_Banana_2_70939.png',
  },
  {
    title: 'Se Nota Que Lo Grabó Alguien Que Labura De Esto',
    quote:
      'No es un curso de power point. Es un pollero de verdad con el pollo en la mano, mostrándote todo. Eso se nota y se agradece.',
    name: 'Yamila S.',
    location: 'San Miguel de Tucumán',
    img: 'https://cdn.magicpatterns.com/uploads/h5AFubiKkJL7ZDdSj3ScDn/Fotografa_hiperrealista_tipo_s_Nano_Banana_2_21612.png',
  },
]

export const INCLUDES = [
  {
    title: '+20 Videos En 11 Módulos',
    desc: 'de la mentalidad al mostrador, filmados por un pollero de verdad, con el pollo en la mano.',
    value: 150000,
  },
  {
    title: 'El Módulo de los Secretos',
    desc: 'cómo detectar pollo inyectado, sacarle el máximo rinde al cajón y no tirar ni los menudos.',
  },
  {
    title: 'Acceso de Por Vida',
    desc: 'mirá los videos las veces que quieras, desde el celu, cuando lo necesites.',
  },
  {
    title: 'Trámites Resueltos',
    desc: 'habilitación, bromatología y cobros con Mercado Pago, paso a paso.',
  },
  {
    title: 'Método 100% Argentino',
    desc: 'adaptado a proveedores, precios y trámites reales, no a manuales de otro país.',
  },
]

export const BONUSES = [
  {
    n: 1,
    title: 'Calculadora de Rinde del Pollo',
    desc: 'Sacá tu costo real por kilo, sin adivinar. Esta es la misma planilla que uso yo para saber exactamente cuánto me queda de cada cajón antes de ponerle un precio a la carne.',
    value: 25000,
    img: 'https://cdn.magicpatterns.com/uploads/oCg3F1WD3Ev12BS6FS5Jir/6-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/w7njGTAg5a9TA36xD7myaK/6-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/vcVtrocwqjDXw4A53hfbp6/6-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/rdxAqeFdk5HKt2Dthz1wXq/6-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/oCg3F1WD3Ev12BS6FS5Jir/6-700.jpg',
    },
  },
  {
    n: 2,
    title: 'Calculadora Para Marcar Precios',
    desc: 'A cuánto vender cada corte para ganar de verdad, no para «cubrir gastos». Cargás tus números y te tira el precio de venta que te garantiza margen.',
    value: 12900,
    img: 'https://cdn.magicpatterns.com/uploads/rA7jKL3LoXNDCXxjfpQa35/7-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/nvvS5iBEkF13qwsTMdcYAS/7-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/uVfw9TbWfrktgcCuqSdta8/7-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/grWjxcGaFt7Xxak1qfvfHM/7-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/rA7jKL3LoXNDCXxjfpQa35/7-700.jpg',
    },
  },
  {
    n: 3,
    title: 'Lista de Proveedores',
    desc: 'La pieza clave para que no te claven precio ni te vendan pollo de dudosa procedencia. Un listado armado con años de mostrador para que arranques con proveedores serios, no a ciegas.',
    value: 20000,
    img: 'https://cdn.magicpatterns.com/uploads/hggqXygYkUL8j6znjcT1sJ/8-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/35x925vCrGZvwLEASFDt5w/8-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/uvW2pavprYwMEz1uRcthMA/8-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/mPcX3UvX4P8TmdEVAbLR8A/8-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/hggqXygYkUL8j6znjcT1sJ/8-700.jpg',
    },
  },
  {
    n: 4,
    title: '"Qué Hacer Con Lo Que Tirás"',
    desc: 'Una mini-guía de aprovechamiento para que dejes de tirar plata a la basura junto con los descartes. Menudos, huesos y recortes que hoy tirás, mañana te generan un ingreso extra.',
    value: 25000,
    img: 'https://cdn.magicpatterns.com/uploads/e4P9HcJirDAaXSLiJGT2bD/9-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/rnKXAEJT3jBTPgaeRLrGaB/9-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/iaFLF7DChDSid5dq7mYDem/9-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/1n6A5vtjDVMfQgdVkAH5ZE/9-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/e4P9HcJirDAaXSLiJGT2bD/9-700.jpg',
    },
  },
  {
    n: 5,
    title: 'Cómo Crear y Enlazar tu Cuenta de Mercado Pago',
    desc: 'Paso a paso para crear tu cuenta de Mercado Pago y vincularla a tu POS de Mercado Pago, para cobrar en el mostrador sin vueltas.',
    value: 15000,
    img: 'https://cdn.magicpatterns.com/uploads/tofJJACsvFZJPAnLTyAmP1/10-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/vJGAyeERAVakxaQzcuAFF1/10-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/wmEcLnVboQ6T39NRa7X8o7/10-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/8doL7USn82zwdKF96Fc3Yx/10-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/tofJJACsvFZJPAnLTyAmP1/10-700.jpg',
    },
  },
  {
    n: 6,
    title: 'Cómo Armar y Exhibir tu Batea',
    desc: 'Guía visual de cómo acomodar y exhibir los cortes de pollo en la batea para que se vendan solos.',
    value: 18000,
    img: 'https://cdn.magicpatterns.com/uploads/1YhgZuwu7rzxtzFQVHYomR/11-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/9u1wApq6A87qX3r4sUitp5/11-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/ib1k1bq2T8J1mmqSAw5ucJ/11-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/qyEXTc9oDus2ZTUaJfCwzK/11-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/1YhgZuwu7rzxtzFQVHYomR/11-700.jpg',
    },
  },
  {
    n: 7,
    title: 'Guía de Habilitación y Bromatología',
    desc: 'PDF descargable con los requisitos generales de bromatología y habilitación para una pollería en Argentina, aclarando que los requisitos municipales varían según la zona.',
    value: 30000,
    img: 'https://cdn.magicpatterns.com/uploads/evgdNHbfmYpvrCy7HHNgjs/12-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/iQWLXPXraNUx1juqBFCY2e/12-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/t4qGEgRwM4nZemg6bRPBqX/12-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/mwCGdRKL5r6zGT3UEyZkbB/12-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/evgdNHbfmYpvrCy7HHNgjs/12-700.jpg',
    },
  },
  {
    n: 8,
    title: 'Cómo Conseguir tus Primeros Clientes al Abrir',
    desc: 'PDF descargable con 6 acciones simples para llenar tu pollería desde la primera semana: radio local, volanteo, grupos de Facebook, delivery, redes sociales y estados de WhatsApp.',
    value: 20000,
    img: 'https://cdn.magicpatterns.com/uploads/9UZB7qETYEFNaGb6qB94pW/13-700.jpg',
    imgSet: {
      webp400:
        'https://cdn.magicpatterns.com/uploads/asU7edexEFB6VRzxxtvGeT/13-400.webp',
      webp700:
        'https://cdn.magicpatterns.com/uploads/aWHN1AJXc9dtV4FWfPZR9R/13-700.webp',
      jpg400:
        'https://cdn.magicpatterns.com/uploads/psHMFhQSf6stZ2V1pPwUnA/13-400.jpg',
      jpg700:
        'https://cdn.magicpatterns.com/uploads/9UZB7qETYEFNaGb6qB94pW/13-700.jpg',
    },
  },
]

export const FAQS = [
  {
    q: '¿Cómo accedo a los videos y las calculadoras? ¿Me llega algo a casa?',
    a: 'Todo es digital. Vas a cargar tus datos en la página siguiente y al toque tenés acceso a la plataforma con todos los videos, las 3 calculadoras y los 8 bonos. No hay cuota mensual de ningún tipo. Pagás una sola vez y eso es todo.',
  },
  {
    q: 'No tengo plata para arrancar en grande. ¿Esto me sirve igual?',
    a: 'Justamente por eso está armado así. No hace falta arrancar con el local más grande ni con la heladera más cara. Yo arranqué con un cajón prestado y de ahí salió todo. El sistema te muestra cómo escalar de a poco, sin fundirte en el intento.',
  },
  {
    q: '¿Hay alguna cuota mensual?',
    a: 'NO. Si entrás con esta oferta, es un pago único de $29.990 por acceso de por vida a todo el sistema y los bonos.',
  },
  {
    q: '¿Por qué el descuento es tan grande? ¿Cuál es el truco?',
    a: 'No hay truco. Es una oferta de lanzamiento por tiempo limitado para premiar a los que se deciden rápido. Cuando esta página se actualice, el precio va a subir a $359.999. Pero para los que llegan a tiempo, el precio es un pago único de $29.990.',
  },
  {
    q: '¿Y si recién estoy arrancando y no sé nada del tema?',
    a: 'Creo que cualquiera puede aprender a llevar una pollería rentable. El sistema arranca desde cero, explicando todo paso a paso, incluida la mentalidad antes que la técnica. Si podés seguir instrucciones simples, podés seguir este sistema.',
  },
  {
    q: 'Ya tengo mi pollería hace años. ¿Esto me sirve o es solo para el que arranca?',
    a: 'Te sirve especialmente a vos. Varios módulos están pensados justo para el que ya tiene el local pero siente que labura para el proveedor y no le queda nada — ahí es donde más plata se recupera con el módulo de rinde y las calculadoras.',
  },
  {
    q: '¿Cómo funciona la garantía? Quiero estar seguro de que es segura.',
    a: 'Solo debés compartir tus datos con quien confiás al 100%. Tu compra queda protegida con mi garantía de 30 días. Si no te convence por cualquier motivo, me escribís y te devuelvo el 100% de tu plata, sin preguntas ni letra chica.',
  },
  {
    q: '¿Por cuánto tiempo tengo acceso al sistema?',
    a: 'Tenés acceso de por vida a todos los videos, calculadoras y bonos. Tu acceso nunca vence y podés volver a mirar cualquier módulo cuando lo necesites.',
  },
]
